export const banners = {
  gift: {
    title: 'Send a gift to friends and family',
    description: 'Now your loved ones can try AG1 with the gift of daily Foundational Nutrition.',
    iconAccessibleName: 'Gift',
    imageAccessibleName: 'Gift',
    buttonCloseLabel: 'Close',
    buttonShopLabel: 'Shop Gifts'
  },
  paymentMethod: {
    title: 'Missing payment method',
    description:
      'Please add a payment method to your susbcription to continue receiving subscription orders.',
    addCtaBtnLabel: 'Add Now',
    updateCtaBtnLabel: 'Update Now'
  },
  stockBanner:
    'Products in your next shipment are currently out of stock and will not be shipped. Out of stock items are excluded from your order total.',
  upcomingOrderBanner: {
    preparing: 'Preparing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    preparingDescription: 'We’re preparing your order.',
    shippedDescription: 'Your current order is on its way.',
    deliveredDescription: 'Hooray! You’ve got AG1.',
    orderDetailsLink: 'View Order Details',
    trackingLink: 'View Tracking Status'
  },
  cookies: {
    text: 'We use third-party cookies and tracking technologies that collect information about your use of the site. These third parties may use your information for their own purposes, as described in our ',
    link: 'Privacy Policy.'
  },
  promotionalBanner: {
    promotionMessage: 'Great value',
    title: 'More of a good thing',
    descriptionPart1: 'Change your subscription to 2 pouches and get each for $74.50 ',
    descriptionPart2:
      ' — perfect for couples, families and very active members who like a second scoop of AG1 each day.',
    disclaimerFull:
      'It’s always best to consult with your health professional to determine the nutritional mix that’s best for you.',
    disclaimerShort:
      'Consult with your health professional to determine the best nutrition level for you.',
    buttonText: 'Add A Pouch'
  },
  offerSoldOut: 'This offer has sold out',
  offerVariantsSoldOut: {
    soldOut_one: '{{soldOutProducts}} is sold out',
    soldOut_other: '{{soldOutProducts}} are sold out'
  },
  milestoneBanner: {
    dateLabel: 'YOUR START DATE',
    rewardText: "We've added your gift to your next {{nextOrderDate}} order."
  }
};
